import { Locales } from '../../common/interfaces';

export enum Messages {
  SAVE = 'SAVE',
  CANCEL = 'CANCEL',
  FILTER_DATE = 'FILTER_DATE',
  PAGE_NOT_FOUND_MESSAGE = 'PAGE_NOT_FOUND_MESSAGE',
  RELOAD = 'RELOAD',
  LOGOUT = 'LOGOUT',
}
export type MessagesType = {
  [key in Messages]: string;
};

export type MessagesByLocaleType = {
  [key in Locales]: MessagesType;
};
